import { company, footerPolicyLinks, navLinks } from '@/lib/site-data'
import {Instagram, Mail, MapPin} from 'lucide-react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="bg-[#100E1F] text-zinc-400">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 text-lg font-bold text-white">
              <Instagram className="h-5 w-5 text-[#8B5CF6]" />
              Muita Mídia
            </div>
            <p className="mt-3 max-w-sm text-sm leading-relaxed">
              Especialistas em venda de páginas nichadas do Instagram desde 2019. Mais de 7.000
              clientes atendidos e 8.400 páginas vendidas, com verificação manual e seguidores
              100% reais.
            </p>
            <div className="mt-4 flex items-start gap-2 text-sm">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#8B5CF6]" />
              <span>{company.addressShort}</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white">Navegação</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {navLinks.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-white">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white">Políticas</h3>
            <ul className="mt-4 space-y-2 text-sm">
              {footerPolicyLinks.map(link => (
                <li key={link.to}>
                  <Link to={link.to} className="transition-colors hover:text-white">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="mailto:contato@muitamidiaofc.com.br" className="inline-flex items-center gap-2 transition-colors hover:text-white">
                  <Mail className="h-4 w-4" />
                  contato@muitamidiaofc.com.br
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-xs leading-relaxed text-zinc-500">
          <p>
            {company.legalName} · CNPJ {company.cnpj} · {company.addressShort}
          </p>
          <p className="mt-2">
            Este site não é vinculado, endossado ou administrado pelo Facebook/Meta ou pelo
            Instagram. Todos os nomes e marcas citados pertencem aos seus respectivos
            proprietários.
          </p>
          <p className="mt-2">
            © {new Date().getFullYear()} {company.legalName}. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
